import { Component, OnInit, Optional, Inject } from '@angular/core';
import {
  MatDialogRef,
  MAT_DIALOG_DATA,
  MatDialogActions,
  MatDialogClose,
} from '@angular/material/dialog';

import { MatButton } from '@angular/material/button';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'qa-import-question-csv-error-dialog',
  templateUrl: './import-question-csv-error-dialog.component.html',
  styleUrls: ['./import-question-csv-error-dialog.component.scss'],
  imports: [MatDialogActions, MatButton, MatDialogClose, TranslateModule],
})
export class ImportQuestionCsvErrorDialogComponent implements OnInit {
  failedNum: string;

  constructor(
    @Optional()
    public dialogRef: MatDialogRef<ImportQuestionCsvErrorDialogComponent>,
    @Optional() @Inject(MAT_DIALOG_DATA) public data: any
  ) {}

  ngOnInit(): void {
    this.failedNum = this.data.questions.map((x) => x.index + 1).join(', ');
  }
}
